if (!customElements.get('image-gallery')) {
  customElements.define('image-gallery', class ImageGallery extends HTMLElement {
    constructor() {
      super();

      this.imageWrapper = this.querySelector('.image-gallery__main-wrapper');
      this.thumbnailWrapper = this.querySelector('.image-gallery__list');
      this.images = this.imageWrapper.querySelectorAll('.image-gallery__main');
      this.thumbnails = this.thumbnailWrapper.querySelectorAll('.image-gallery__item');
      this.scrollButtons = this.querySelectorAll('.image-gallery__scroll-btn');

      this.thumbnails
        .forEach(thumbnail => thumbnail.addEventListener('click', this.onClickThumbnail.bind(this)));
      this.thumbnails
        .forEach(thumbnail => thumbnail.addEventListener('mouseover', this.onHoverThumbnail.bind(this)));
      this.scrollButtons
        .forEach(thumbnail => thumbnail.addEventListener('click', this.onClickScrollButton.bind(this)));
      this.thumbnailWrapper.addEventListener('scroll', this.updateScrollButtonState.bind(this), {passive: true})
      window.addEventListener('message', this.onVariantChange.bind(this))
      this.update();
    }

    onVariantChange(event) {
      if (!event.data || event.data.type !== 'variant_changed') return;
      // 1. hide thumbnails from other variants
      const variantMediaId = event.data.variant.featured_media.id;
      const variantMediaGroup = event.data.variant.featured_media.alt;
      const productTitle = this.dataset.productTitle;
      const templateVariantMediaId = `${this.dataset.mediaPrefix}${variantMediaId}`;
      this.thumbnails.forEach(thumbnail => {
        const isFeaturedImageFromOtherVariant = thumbnail.classList.contains('image-gallery__item--variant') && thumbnail.dataset.mediaId != templateVariantMediaId;
        const isImageFromOtherVariant = this.dataset.useAltGroup === 'true' && ![productTitle, variantMediaGroup].includes(thumbnail.dataset.mediaAlt);
        const shouldBeHidden = isFeaturedImageFromOtherVariant || isImageFromOtherVariant;
        thumbnail.classList.toggle('hidden', shouldBeHidden);
      })
      // 2. change image, default to first visible thumbnail
      const images = Array.from(this.images);
      let currentImage = images.find(item => item.dataset.plainMediaId == variantMediaId);
      if (!currentImage) {
        const firstVisibleThumbnail = Array.from(this.thumbnails).find(thumbnail => !thumbnail.classList.contains('hidden'));
        if (!firstVisibleThumbnail) {
          currentImage = images[0];
        } else {
          currentImage = images.find(item => item.dataset.mediaId == firstVisibleThumbnail.dataset.mediaId);
        }
      }
      this.selectImage(currentImage.dataset.mediaId)
    }

    selectImage(mediaId) {
      const thumbnail = Array.from(this.thumbnails).find(thumbnail => thumbnail.dataset.mediaId === mediaId);
      const image = Array.from(this.images).find(image => image.dataset.mediaId === mediaId);
      if (!thumbnail || thumbnail.classList.contains('image-gallery__item--active')) {
        return;
      }
      this.imageWrapper.querySelector('.image-gallery__main--active').classList.remove('image-gallery__main--active');
      this.thumbnailWrapper.querySelector('.image-gallery__item--active').classList.remove('image-gallery__item--active');

      thumbnail.classList.add('image-gallery__item--active')
      image.classList.add('image-gallery__main--active');
      this.update();
      
      // auto play deferred media
      const deferred_media = image.querySelector('[id^="Deferred-Poster-"]');
      if (deferred_media) deferred_media.click();
    }
    
    onHoverThumbnail(event) {
      if (this.hoverThumbnailTimeout) {
        clearTimeout(this.hoverThumbnailTimeout)
        this.hoverThumbnailTimeout = null;
      }
      this.hoverThumbnailTimeout = setTimeout(
        () => {
          const el = event.target.parentElement;
          this.selectImage(el.dataset.mediaId)
        }, 200
      );
    }

    onClickThumbnail(event) {
      if (this.hoverThumbnailTimeout) {
        clearTimeout(this.hoverThumbnailTimeout)
        this.hoverThumbnailTimeout = null;
      }
      const el = event.target.parentElement;
      this.selectImage(el.dataset.mediaId)
    }

    onClickScrollButton(event) {
      const el = event.target;
      const direction = el.dataset.direction;
      if (!direction) {
        return;
      }
      if (direction === 'up') {
        this.thumbnailWrapper.scrollBy({top: -100, behavior: 'smooth'});
      } else {
        this.thumbnailWrapper.scrollBy({top: 100, behavior: 'smooth'});
      }
      this.updateScrollButtonState();
    }

    update() {
      this.style.height = `${this.imageWrapper.offsetHeight}px`;
      this.updateScrollButtonState();
    }

    updateScrollButtonState() {
      const state = {
        up: false,
        down: false,
      }
      if (this.thumbnailWrapper.offsetHeight < this.thumbnailWrapper.scrollHeight) {
        if (this.thumbnailWrapper.scrollTop > 0) {
          state.up = true;
        }

        if (this.thumbnailWrapper.scrollTop + this.thumbnailWrapper.offsetHeight < this.thumbnailWrapper.scrollHeight - 10) {
          state.down = true;
        }
      }
      this.scrollButtons.forEach(button => {
        const direction = button.dataset.direction;
        if (!direction) {
          return;
        }
        if (state[direction]) {
          button.classList.remove('hidden');
        } else {
          button.classList.add('hidden');
        }
      })
    }
  });
}
